import { Component } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import * as Highcharts from 'highcharts';
import { Icon } from './core/_enums/icon';
import { LabelI18nService } from './core/_services/label-i18n.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'web-seve-app';

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private translate: TranslateService,
    private dateAdapter: DateAdapter<Date>,
    private labelI18n: LabelI18nService
  ) {
    this.matIconRegistry.addSvgIcon(Icon.Route, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/route.svg'));
    this.matIconRegistry.addSvgIcon(Icon.Building, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/building.svg'));
    this.matIconRegistry.addSvgIcon(Icon.Excavator, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/excavator.svg'));
    this.matIconRegistry.addSvgIcon(Icon.OilBarrel, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/oil-barrel.svg'));
    this.matIconRegistry.addSvgIcon(Icon.Highway, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/highway.svg'));
    this.matIconRegistry.addSvgIcon(Icon.Truck, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/truck.svg'));
    this.matIconRegistry.addSvgIcon(Icon.Gasoline, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/gasoline.svg'));
    this.matIconRegistry.addSvgIcon(Icon.Member, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/member.svg'));
    this.matIconRegistry.addSvgIcon(Icon.Email, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/email.svg'));
    this.matIconRegistry.addSvgIcon(Icon.Administration, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/administration.svg'));
    this.matIconRegistry.addSvgIcon(Icon.Statistic, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/statistic.svg'));
    this.matIconRegistry.addSvgIcon(Icon.User, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/user.svg'));
    this.matIconRegistry.addSvgIcon(Icon.Energy, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/energy.svg'));
    this.matIconRegistry.addSvgIcon(Icon.Industry, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/industry.svg'));
    this.matIconRegistry.addSvgIcon(Icon.UserEntities, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/user-entities.svg'));
    this.matIconRegistry.addSvgIcon(Icon.Sigma, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/sigma.svg'));
    this.matIconRegistry.addSvgIcon(Icon.RadarChart, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/radar.svg'));
    this.matIconRegistry.addSvgIcon(Icon.Youtube, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/youtube.svg'));
    this.matIconRegistry.addSvgIcon(Icon.Structures, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/structures.svg'));
    this.matIconRegistry.addSvgIcon(Icon.List, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/list.svg'));
    this.matIconRegistry.addSvgIcon(Icon.ExcavatorSettings, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/excavatorSettings.svg'));
    this.matIconRegistry.addSvgIcon(Icon.ExcavatorSigma, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/excavatorSigma.svg'));
    this.matIconRegistry.addSvgIcon(Icon.TruckSettings, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/truckSettings.svg'));
    this.matIconRegistry.addSvgIcon(Icon.Water, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/water.svg'));
    this.matIconRegistry.addSvgIcon(Icon.Checklist, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/check.svg'));
    this.matIconRegistry.addSvgIcon(Icon.Dashboard, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/dashboard.svg'));
    this.matIconRegistry.addSvgIcon(Icon.Help, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/help.svg'));
    this.matIconRegistry.addSvgIcon(Icon.Key, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/key.svg'));

    translate.addLangs(['en', 'fr']);
    translate.setDefaultLang('fr');
    translate.use(localStorage.getItem('selectedLanguage') || 'fr');
    this.applyLocale();
    translate.onLangChange.subscribe(() => this.applyLocale());
  }

  private applyLocale() {
    this.dateAdapter.setLocale(this.labelI18n.locale);
    // Highcharts 10 ne lit `lang` que globalement : celui passé dans les options d'un graphique est ignoré.
    const isEnglish = this.translate.currentLang === 'en';
    Highcharts.setOptions({ lang: { decimalPoint: isEnglish ? '.' : ',', thousandsSep: isEnglish ? ',' : ' ' } });
  }
}
